// extracted by mini-css-extract-plugin
export default {"login__button":"style_login__button__NWIkC"};